import { observable, decorate } from 'mobx'

class CompanyProductsStore {
  constructor (rootStore) {
    this.state = {
      '4REINF': {
        store: rootStore.stores.editReinfStore
      }
    }
  }

  setProductFormData (product, data, id) {
    this.state[product].store.setFormData(data, id)
  }

  openProductModal (product) {
    this.state[product].store.openModal()
  }

  closeProductModal (product) {
    this.state[product].store.closeModal()
  }
}

decorate(CompanyProductsStore, {
  state: observable
})

export default CompanyProductsStore



// WEBPACK FOOTER //
// ./src/stores/config/companyProductStore.js